module.exports = __webpack_public_path__ + "img/yourweb.36f1e033.png";